import { useBrandingEditorLockLifecycle } from './useBrandingEditorLockLifecycle';

/**
 * Mount point for the Editor Mode lock lifecycle. Renders nothing; lives next
 * to `EditorMode` on the event page so it outlives the editor overlay itself.
 */
const BrandingEditorLockBridge = () => {
  useBrandingEditorLockLifecycle();

  return null;
};

export default BrandingEditorLockBridge;
